module.exports = __webpack_public_path__ + "images/cross35f17f2197002c76576943ba8e5380bd.svg";